export function round(value: number, decimals: number = 0): number {
  const pow = Math.pow(10, decimals);
  return Math.round(value * pow) / pow;
}
